/* DO NOT EDIT THIS FILE BY HAND!
 * This file is auto-generated by a script, generate-icon-enum.ts, based off the glyphs in the helix icons svg file.
 * To re-generate this file, run the following in the kyoko directory
 *
 * $> yarn generate
 */

/**
 * Icons defined in our helix icons font.
 */
export enum IconName {
  Annotation = 'hi-annotation',
  Archive = 'hi-archive',
  Arrange = 'hi-arrange',
  ArrowDown = 'hi-arrow-down',
  ArrowDownCircle = 'hi-arrow-down-circle',
  ArrowLeft = 'hi-arrow-left',
  ArrowLeftCircle = 'hi-arrow-left-circle',
  ArrowLeftRight = 'hi-arrow-left-right',
  ArrowNarrowDown = 'hi-arrow-narrow-down',
  ArrowNarrowLeft = 'hi-arrow-narrow-left',
  ArrowNarrowRight = 'hi-arrow-narrow-right',
  ArrowNarrowUp = 'hi-arrow-narrow-up',
  ArrowRedo = 'hi-arrow-redo',
  ArrowRight = 'hi-arrow-right',
  ArrowRightCircle = 'hi-arrow-right-circle',
  ArrowUndo = 'hi-arrow-undo',
  ArrowUp = 'hi-arrow-up',
  ArrowUpCircle = 'hi-arrow-up-circle',
  ArrowUpDown = 'hi-arrow-up-down',
  ArrowsExpand = 'hi-arrows-expand',
  ArrowsReduce = 'hi-arrows-reduce',
  AtSymbol = 'hi-at-symbol',
  Ban = 'hi-ban',
  BarsHorizontal = 'hi-bars-horizontal',
  BarsVertical = 'hi-bars-vertical',
  Bell = 'hi-bell',
  BookOpen = 'hi-book-open',
  Bookmark = 'hi-bookmark',
  Braces = 'hi-braces',
  BringBackward = 'hi-bring-backward',
  BringForward = 'hi-bring-forward',
  Calculator = 'hi-calculator',
  Calendar = 'hi-calendar',
  CalendarEnd = 'hi-calendar-end',
  CalendarStart = 'hi-calendar-start',
  Camera = 'hi-camera',
  Cash = 'hi-cash',
  ChartBar = 'hi-chart-bar',
  ChartBarBox = 'hi-chart-bar-box',
  ChartDonut = 'hi-chart-donut',
  ChartLine = 'hi-chart-line',
  ChartPie = 'hi-chart-pie',
  ChartPie025 = 'hi-chart-pie-025',
  ChartPie050 = 'hi-chart-pie-050',
  ChartPie075 = 'hi-chart-pie-075',
  ChartPie100 = 'hi-chart-pie-100',
  Chat = 'hi-chat',
  Check = 'hi-check',
  CheckCheckbox = 'hi-check-checkbox',
  CheckCircle = 'hi-check-circle',
  CheckCircleSolid = 'hi-check-circle-solid',
  CheckIndeterminate = 'hi-check-indeterminate',
  CheckMultiple = 'hi-check-multiple',
  ChevronDoubleDown = 'hi-chevron-double-down',
  ChevronDoubleLeft = 'hi-chevron-double-left',
  ChevronDoubleRight = 'hi-chevron-double-right',
  ChevronDoubleUp = 'hi-chevron-double-up',
  ChevronDown = 'hi-chevron-down',
  ChevronLeft = 'hi-chevron-left',
  ChevronRight = 'hi-chevron-right',
  ChevronUp = 'hi-chevron-up',
  ChevronUpDown = 'hi-chevron-up-down',
  Chip = 'hi-chip',
  Circle = 'hi-circle',
  CircleDotted = 'hi-circle-dotted',
  CircleSolid = 'hi-circle-solid',
  ClearMultiple = 'hi-clear-multiple',
  ClipboardCheck = 'hi-clipboard-check',
  ClipboardCopy = 'hi-clipboard-copy',
  ClipboardList = 'hi-clipboard-list',
  ClipboardPaste = 'hi-clipboard-paste',
  Clock = 'hi-clock',
  ClockEnd = 'hi-clock-end',
  Close = 'hi-close',
  CloseCircle = 'hi-close-circle',
  CloseCircleSolid = 'hi-close-circle-solid',
  Cloud = 'hi-cloud',
  CloudDownload = 'hi-cloud-download',
  CloudUpload = 'hi-cloud-upload',
  Code = 'hi-code',
  Cog = 'hi-cog',
  Collection = 'hi-collection',
  ColorSwatch = 'hi-color-swatch',
  Columns = 'hi-columns',
  CommandCmd = 'hi-command-cmd',
  Comment = 'hi-comment',
  Connector = 'hi-connector',
  Counterparty = 'hi-counterparty',
  CreditCard = 'hi-credit-card',
  Crown = 'hi-crown',
  Cube = 'hi-cube',
  CubeTransparent = 'hi-cube-transparent',
  CurrencyDollar = 'hi-currency-dollar',
  CurrencyEuro = 'hi-currency-euro',
  CurrencyPound = 'hi-currency-pound',
  DataCross = 'hi-data-cross',
  DataIsolated = 'hi-data-isolated',
  Database = 'hi-database',
  Deepdive = 'hi-deepdive',
  DeltaSingle = 'hi-delta-single',
  DeltaStacked = 'hi-delta-stacked',
  DeviceDesktop = 'hi-device-desktop',
  DeviceDesktopWide = 'hi-device-desktop-wide',
  DeviceLaptop = 'hi-device-laptop',
  DeviceMobile = 'hi-device-mobile',
  DeviceTablet = 'hi-device-tablet',
  Document = 'hi-document',
  DocumentAdd = 'hi-document-add',
  DocumentCheck = 'hi-document-check',
  DocumentClear = 'hi-document-clear',
  DocumentDownload = 'hi-document-download',
  DocumentDuplicate = 'hi-document-duplicate',
  DocumentRemove = 'hi-document-remove',
  DocumentReport = 'hi-document-report',
  DocumentSearch = 'hi-document-search',
  DocumentSign = 'hi-document-sign',
  DocumentText = 'hi-document-text',
  DocumentUpload = 'hi-document-upload',
  Dot = 'hi-dot',
  DotSolid = 'hi-dot-solid',
  DotsHorizontal = 'hi-dots-horizontal',
  DotsVertical = 'hi-dots-vertical',
  Download = 'hi-download',
  DragHorizontal = 'hi-drag-horizontal',
  DragVertical = 'hi-drag-vertical',
  Duplicate = 'hi-duplicate',
  EmojiHappy = 'hi-emoji-happy',
  EmojiSad = 'hi-emoji-sad',
  Enter = 'hi-enter',
  Exclamation = 'hi-exclamation',
  ExclamationCircle = 'hi-exclamation-circle',
  ExclamationCircleSolid = 'hi-exclamation-circle-solid',
  ExclamationSolid = 'hi-exclamation-solid',
  Exit = 'hi-exit',
  ExpandLeft = 'hi-expand-left',
  ExpandRight = 'hi-expand-right',
  ExternalLink = 'hi-external-link',
  EyeHide = 'hi-eye-hide',
  EyeShow = 'hi-eye-show',
  FastForward = 'hi-fast-forward',
  FastRewind = 'hi-fast-rewind',
  Feed = 'hi-feed',
  Fees = 'hi-fees',
  Film = 'hi-film',
  Filter = 'hi-filter',
  Flag = 'hi-flag',
  Folder = 'hi-folder',
  FolderAdd = 'hi-folder-add',
  FolderDownload = 'hi-folder-download',
  FolderOpen = 'hi-folder-open',
  FolderRemove = 'hi-folder-remove',
  Globe = 'hi-globe',
  GridAdd = 'hi-grid-add',
  Hashtag = 'hi-hashtag',
  Heart = 'hi-heart',
  HeartSolid = 'hi-heart-solid',
  Home = 'hi-home',
  Identification = 'hi-identification',
  Image = 'hi-image',
  Inbox = 'hi-inbox',
  InboxIn = 'hi-inbox-in',
  InformationCircle = 'hi-information-circle',
  InformationCircleSolid = 'hi-information-circle-solid',
  Key = 'hi-key',
  KeyClock = 'hi-key-clock',
  LightBulb = 'hi-light-bulb',
  LightningBolt = 'hi-lightning-bolt',
  Link = 'hi-link',
  ListCollapse = 'hi-list-collapse',
  ListExpand = 'hi-list-expand',
  ListGroup = 'hi-list-group',
  LocationMarker = 'hi-location-marker',
  LockClosed = 'hi-lock-closed',
  LockOpen = 'hi-lock-open',
  Login = 'hi-login',
  Logout = 'hi-logout',
  Mail = 'hi-mail',
  MailOpen = 'hi-mail-open',
  Map = 'hi-map',
  Menu = 'hi-menu',
  Microphone = 'hi-microphone',
  Minus = 'hi-minus',
  MinusBox = 'hi-minus-box',
  MinusCircle = 'hi-minus-circle',
  Moon = 'hi-moon',
  MusicNote = 'hi-music-note',
  Newspaper = 'hi-newspaper',
  OfficeBuilding = 'hi-office-building',
  OrderBook = 'hi-order-book',
  OrderBookAsks = 'hi-order-book-asks',
  OrderBookBids = 'hi-order-book-bids',
  PanelCog = 'hi-panel-cog',
  PaperAirplane = 'hi-paper-airplane',
  PaperClip = 'hi-paper-clip',
  Pause = 'hi-pause',
  PauseCircle = 'hi-pause-circle',
  Pencil = 'hi-pencil',
  PencilField = 'hi-pencil-field',
  Phone = 'hi-phone',
  Pin = 'hi-pin',
  PinOff = 'hi-pin-off',
  Play = 'hi-play',
  PlayCircle = 'hi-play-circle',
  Plus = 'hi-plus',
  PlusBox = 'hi-plus-box',
  PlusCircle = 'hi-plus-circle',
  Preferences = 'hi-preferences',
  PresentationChartBar = 'hi-presentation-chart-bar',
  PresentationChartLine = 'hi-presentation-chart-line',
  Printer = 'hi-printer',
  Puzzle = 'hi-puzzle',
  Qrcode = 'hi-qrcode',
  QuestionMarkCircle = 'hi-question-mark-circle',
  Refresh = 'hi-refresh',
  RefreshRecover = 'hi-refresh-recover',
  Reorder = 'hi-reorder',
  Repeat = 'hi-repeat',
  RepeatOnce = 'hi-repeat-once',
  Reply = 'hi-reply',
  RestTime = 'hi-rest-time',
  Save = 'hi-save',
  SaveAs = 'hi-save-as',
  Scale = 'hi-scale',
  Search = 'hi-search',
  Selector = 'hi-selector',
  Server = 'hi-server',
  Share = 'hi-share',
  Shield = 'hi-shield',
  ShieldCheck = 'hi-shield-check',
  ShieldExclamation = 'hi-shield-exclamation',
  SidebarPinned = 'hi-sidebar-pinned',
  SidebarUnpinned = 'hi-sidebar-unpinned',
  SortAscending = 'hi-sort-ascending',
  SortCumulative = 'hi-sort-cumulative',
  SortDescending = 'hi-sort-descending',
  SortUnordered = 'hi-sort-unordered',
  Speakerphone = 'hi-speakerphone',
  Star = 'hi-star',
  StarIntermediate = 'hi-star-intermediate',
  StarSolid = 'hi-star-solid',
  StatusOffline = 'hi-status-offline',
  StatusOnline = 'hi-status-online',
  Stop = 'hi-stop',
  StopCircle = 'hi-stop-circle',
  Sun = 'hi-sun',
  Support = 'hi-support',
  Table = 'hi-table',
  Template = 'hi-template',
  Terminal = 'hi-terminal',
  Theme = 'hi-theme',
  ThumbDown = 'hi-thumb-down',
  ThumbUp = 'hi-thumb-up',
  Ticket = 'hi-ticket',
  Timer = 'hi-timer',
  Translate = 'hi-translate',
  Trash = 'hi-trash',
  TreeDiagram = 'hi-tree-diagram',
  TrendDown = 'hi-trend-down',
  TrendUp = 'hi-trend-up',
  TrendingDown = 'hi-trending-down',
  TrendingUp = 'hi-trending-up',
  TriangleDown = 'hi-triangle-down',
  TriangleLeft = 'hi-triangle-left',
  TriangleRight = 'hi-triangle-right',
  TriangleUp = 'hi-triangle-up',
  Upload = 'hi-upload',
  User = 'hi-user',
  UserAdd = 'hi-user-add',
  UserCircle = 'hi-user-circle',
  UserCog = 'hi-user-cog',
  UserGroup = 'hi-user-group',
  UserRemove = 'hi-user-remove',
  Users = 'hi-users',
  Variable = 'hi-variable',
  VideoCamera = 'hi-video-camera',
  ViewGrid = 'hi-view-grid',
  ViewList = 'hi-view-list',
  ViewListDrilldown = 'hi-view-list-drilldown',
  VolumeOff = 'hi-volume-off',
  VolumeUp = 'hi-volume-up',
  Wallet = 'hi-wallet',
  Wifi = 'hi-wifi',
  ZoomIn = 'hi-zoom-in',
  ZoomOut = 'hi-zoom-out',
  ZoomReset = 'hi-zoom-reset',
}
